import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  enabled?: boolean;
}

const useMyTeams = ({ enabled = true }: IProps = {}) => {
  const query = useQuery({
    queryKey: ['teams', 'my'],
    queryFn: async () => {
      const response = await Api.myTeams();
      return response.data.data;
    },
    enabled,
  });

  return {
    teams: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useMyTeams;
